import React from "react";
import { Modal, Radio } from "antd";
import styled from "styled-components";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import ReactMarkdown from "react-markdown";

import { getDataVersionBE } from "redux/slices/authenticated";
import { InfoVersion } from "util/versionData";

const ModalVersion = ({ modalVersion, setModalVersion }) => {
  const dispatch = useDispatch();
  const { dataVersionBE } = useSelector((state) => state.authenticatedReducer);

  const [view, setView] = useState("fe");
  const _onCancel = () => {
    setModalVersion(false);
  };

  useEffect(() => {
    if (modalVersion) {
      dispatch(getDataVersionBE());
    }
  }, [modalVersion, dispatch]);

  return (
    <ModalCustom
      title="Version"
      visible={modalVersion}
      footer={null}
      width={1000}
      onCancel={_onCancel}
      centered
    >
      <CustomOption
        value={view}
        onChange={(e) => {
          setView(e.target.value);
        }}
      >
        <Radio value="fe">Version FE</Radio>
        <Radio value="be">Version BE</Radio>
      </CustomOption>
      {view === "fe" ? (
        <>
          {InfoVersion.map((version, index) => {
            return (
              <>
                <BasicInfo key={index}>
                  <legend>
                    v{version.version} - {version?.create_day}
                  </legend>
                  <Content>
                    <Group>
                      <CustomTitle>New feature</CustomTitle>
                      <GroupContent>
                        {version.new_feature.map((feature, idx) => {
                          return (
                            <ItemWrap key={idx}>{feature.content}</ItemWrap>
                          );
                        })}
                      </GroupContent>
                    </Group>
                    <Group>
                      <CustomTitle>Bug fix</CustomTitle>
                      <GroupContent>
                        {version.fix_bug.map((bug, idx) => {
                          return <ItemWrap key={idx}>{bug.content}</ItemWrap>;
                        })}
                      </GroupContent>
                    </Group>
                  </Content>
                </BasicInfo>
              </>
            );
          })}
        </>
      ) : (
        <ReactMarkdown source={dataVersionBE}>{dataVersionBE}</ReactMarkdown>
      )}
    </ModalCustom>
  );
};

export default ModalVersion;

const ModalCustom = styled(Modal)`
  .ant-modal-content {
    border-radius: 10px;
  }

  .ant-modal-header {
    border-radius: 10px 10px 0 0;
    background: #f2f4f5;
    padding: 7px 24px;
  }

  .ant-modal-title {
    font-family: var(--roboto-700);
  }

  .ant-modal-close-x {
    height: 36.6px;
    line-height: 36.6px;

    .anticon {
      color: #141414;
    }
  }

  .ant-form-item-label > label {
    font-size: 16px;
    color: #2c2c2c;
  }

  .ant-modal-body {
    height: 660px;
    overflow: auto;
  }
`;

const CustomOption = styled(Radio.Group)`
  .ant-radio-checked .ant-radio-inner,
  .ant-radio:hover .ant-radio-inner,
  .ant-radio-checked::after {
    border-color: ${(props) => props.theme.main};
  }

  .ant-radio-input:focus + .ant-radio-inner {
    box-shadow: none;
  }

  .ant-radio-inner::after {
    background-color: ${(props) => props.theme.main};
  }
  span {
    font-size: 16px;
  }
`;

const Content = styled.div`
  display: flex;
  justify-content: space-between;

  flex-wrap: wrap;
  width: 100%;

  iframe {
    width: 100%;
    border-width: inherit;
    height: 600px;
  }
`;

const Group = styled.div`
  width: 440px;

  border: 1px solid #ececec;
  border-radius: 5px;
  margin: 6px;
  box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.05);
`;
const CustomTitle = styled.div`
  font-family: var(--roboto-500);
  font-size: 16px;
  color: #000000;
  background: #efeff4;
  padding: 11px 10px;
`;

const GroupContent = styled.div`
  padding: 8px;
  max-height: 400px;
  overflow: auto;
`;
const ItemWrap = styled.div`
  font-size: 16px;
  margin-bottom: 8px;
`;

const BasicInfo = styled.fieldset`
  padding: 6px 16px 16px 16px;
  border: 1px solid #ececec;
  border-radius: 5px;
  margin-top: 10px;
  legend {
    width: fit-content;
    color: ${(props) => props.theme.main};
    font-size: 16px;
    padding: 0 8px;
    margin-bottom: 0;
    border-bottom: none;
    font-family: var(--roboto-500);
  }
`;
